import React from "react";
import { PhoneDubaiIcon } from "../../../../app-constants";
import { Link } from "gatsby";

const Sidebtns = () => {
  return (
    <div className="sidebtns-dubai">
      <div className="side-box">
        <ul>
          <li>
            <Link
              to="tel:+8003629239"
              aria-label=""
              target="_blank"
              rel="noopener"
            >
              {PhoneDubaiIcon}
            </Link>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default Sidebtns;
